import React from 'react';
import { Button, Image } from '@chakra-ui/react';
import pencilIcon from '/assets/images/icons/pencil.svg';

interface EditButtonProps {
  onClick: () => void;
  label: string;
  size?: 'default' | 'large';
  'data-testid'?: string;
}

const AleaEditButton: React.FC<EditButtonProps> = ({ onClick, label, size = 'default', 'data-testid': dataTestId }) => {
  const isLarge = size === 'large';
  
  return (
    <Button
      data-testid={dataTestId}
      leftIcon={<Image src={pencilIcon} />}
      variant="outline"
      iconSpacing="5px"
      onClick={onClick}
      sx={{
        height: isLarge ? '50px' : '30px',
        fontWeight: 400,
        pl: isLarge ? '10px' : '5px',
        pr: isLarge ? '15px' : '10px',
        borderRadius: '20px',
        borderColor: '#DCDCDC',
        color: 'alea.500',
        mr: '10px',
        backgroundColor: '#F3F2F2'
      }}
    >
      {label}
    </Button>
  );
};

export default AleaEditButton;
